import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Checkbox,
  ListItemIcon,
  ListItemText,
  Grid,
  Button,
  Input,
} from "@material-ui/core";
import { getToday } from "../utils/varialbles";
import { makeStyles } from "@material-ui/core/styles";
import http from "../services/httpService";
let statusArray = {
  I: "Interested",
  N: "Not Interested",
  L: "Later",
  O: "No Answer",
  S: "No Status",
};

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

function Filter(props) {
  const {
    // clearFilter,
    setAppliedFilter,
    filterState,
    setFilterState,
    filterList,
    filterString,
    setFilterString,
  } = props.data;


  const classes = useStyles();

  const [testState, setTestState] = React.useState([]);

  //console uponchange
  useEffect(
    (x) => {
      // (testState);
    },
    [testState]
  );

  // const [filterState, setFilterState] = React.useState(generateEmptyFilterState());
  // const updateFilter = (v, id, meta) => {
  //   setFilterState((fstate) => {
  //     const newState = filterList.map((x) => {
  //       //if this filter id is same as id received as prop
  //       if (x.id === id) {
  //         //check the type and add value according to the value.
  //         if (x.type === "number") {
  //           return {
  //             name: x.name,
  //             id: x.id,
  //             value: parseFloat(v),
  //             // options: v
  //           };
  //         } else if (x.type === "select") {
  //           return {
  //             name: x.name,
  //             id: x.id,
  //             options: v,
  //           };
  //         } else if (x.type === "radio") {
  //           return {
  //             name: x.name,
  //             id: x.id,
  //             options: [v],
  //           };
  //         } else if (x.type === "date") {
  //           // ('date');
  //           // (v);
  //           // return {id: x.id}
  //           if (meta === "option") {
  //             // return {id: x.id, data: {start: v.start, end: v.end}}
  //             // (fstate);
  //             const fstateObject = fstate.find((filter) => filter.id === x.id);
  //             // alert(fstateObject.data);
  //             // const currentValue = fstateObject.data.lessThan?fstateObject.data.lessThan:fstateObject.data.greaterThan;
  //             let currentValue = fstateObject.data.lessThan
  //               ? fstateObject.data.lessThan
  //               : "";
  //             currentValue = fstateObject.data.greaterThan
  //               ? fstateObject.data.greaterThan
  //               : "";
  //             currentValue = fstateObject.data.equalTo
  //               ? fstateObject.data.equalTo
  //               : "";
  //             // (v);
  //             return { id, name: x.name, data: { [v]: currentValue } };
  //             // return {fstateObject., lessThan: "", greaterThan: "", [v]: }
  //           } else if (meta === "value") {
  //             // this time, key should remain but value should be changed
  //             const fstateObject = fstate.find((filter) => filter.id === x.id);
  //             // (fstateObject);
  //             //check if lessThan property is there without checking for value
  //             const currentValue = Object.keys(fstateObject.data)[0];
  //             // const currentValue = fstateObject.data.lessThan?"lessThan":"greaterThan";
  //             return { id, name: x.name, data: { [currentValue]: v } };
  //           }
  //         }
  //       } else {
  //         return fstate.find((filter) => filter.id === x.id);
  //       }
  //     });
  //     // (newState);
  //     return newState;
  //   });
  // };

  // (filterList);

  // const shouldNameDisplay = (filter) => {
  //   // const exceptionCase = location.url
  //   return filter.showName ? filter.name : "";
  // };

  // const [filterString, setFilterString] = React.useState("");
  // (filterString);

  const [showSubMenu, setSubMenu] = useState(false);
  const [showSubChildMenu, setSubChildMenu] = useState(false);

  const [filterType, setFilterType] = useState("");
  const [filterFinalType, setFilterFinalType] = useState("");
  // (filterType);
  // const [filterObject, setFilterObject] = useState({});
  // (filterObject);

  // const [filterArray, setFilterArray] = useState([]);
  // (filterArray);

  const [filterValue, setFilterValue] = useState("");
  // (filterValue);

  const [filterValueFinalString, setFilterValueFinalString] = useState("");
  // (filterValueFinalString);

  const [filterSubValue, setFilterSubValue] = useState("");
  // (filterSubValue);

  const [handleRangeData, setHandleRangeData] = useState({
    from: "",
    to: "",
  });
  // (handleRangeData);

  //   const filterRangeFinalArray = Object.values(handleRangeData).filter((x) => x.length > 0);

  const filterRangeFinalArray = `${handleRangeData.from},${handleRangeData.to}`;
  // (filterRangeFinalArray);

  const finalFilterTypeObj = {
    "RM Name": "RM",
    Status: "status",
    "Service Type": "serviceType",
    "Referee Visits": "refree_visits",
    "Successful referrals": "success_refs",
    "Referrals Shared": "ref_shared",
    "Referral Bonus": "ref_bonus",
    // Country: "country",
    "Issue Type": "issueType",
    Reporter: "reporter",
    "Assigned To": "assignedTo",
    Severity: "severity",
    Frequency: "frequency",
    "Preferred Language": "language",
    "Critical CDT Reminders": "ccdtReminders",
    "Subscription Status": "subscription_status",
    Conditions: "filter_data",

    "Expiry Date": "expiryDate_",
    "Signup Date": "signup_",
    "Get Back Date": "getback_",
    "Created Date": "createdDate_",
    "Call Date": "callDate_",
    "Date Time": "callDate_",
    // "Referrals Shared": "ref_shared_",
    "Renewal Date": "renewaldt_",
    "Subscription Date": "subdt_",

    "Asset Class": "assetclass",
    "Country": "country_id",

    ref_shared_value: "ref_shared_value",
    ref_bonus_value: "ref_bonus_value",
    refree_visits_value: "refree_visits_value",
    success_refs_value: "success_refs_value",
  };

  const handleChangeFilter = (e) => {

    setSubMenu(true);
    var filterTypeString = "";
    if (Object.keys(finalFilterTypeObj).includes(e.target.value)) {
      filterTypeString = finalFilterTypeObj[e.target.value];
      // (finalFilterTypeObj[e.target.value]);
      // (filterTypeString);
    }

    // (filterTypeString);
    setFilterType(e.target.value);
    setFilterFinalType(filterTypeString);
  };

  const handleChangeSubFilter = (e) => {

    (e.target.value === "et" ||
      e.target.value === "lte" ||
      e.target.value === "gte" ||
      e.target.value === "range") &&
      setSubChildMenu(true);
    setFilterSubValue(e.target.value);

    !(
      e.target.value === "et" ||
      e.target.value === "lte" ||
      e.target.value === "gte" ||
      e.target.value === "range"
    ) &&
      setFilterValueFinalString("&" + filterFinalType + "=" + e.target.value);
    //  setFilterString("&" + filterFinalType + "=" + e.target.value);

    // setFilterSubValue(e.target.value);
    // setFilterValue(e.target.value);
  };

  const handleChangeChildFilter = (e) => {
    (filterSubValue === "et" ||
      filterSubValue === "lte" ||
      filterSubValue === "gte") &&
      setFilterValueFinalString(
        "&" + filterFinalType + filterSubValue + "=" + e.target.value
      ); /* setFilterString("&" + filterFinalType + filterSubValue + "=" + e.target.value); */
    // (e.target.value);
    // setAppliedFilter(e.target.value);
  };

  const handleChangeChildRangeFilter = (e) => {
    setHandleRangeData({ ...handleRangeData, [e.target.name]: e.target.value });
    // let filterRangeFinalArray = [];
    // (filterRangeFinalArray);
    // filterRangeFinalArray.push(e.target.value);
    // (filterRangeFinalArray);
    // setFilterRangeFinalArray(filterRangeFinalArray.push(e.target.value));
    filterSubValue === "range" &&
      setFilterValueFinalString(
        "&" + filterFinalType + filterSubValue + "=" + filterRangeFinalArray
      ); /* setFilterString("&" + filterFinalType + filterSubValue + "=" + filterRangeFinalArray); */
  };

  // const [finalFilterString, setFinalFilterString] = useState("");

  useEffect(
    (x) => {
      // (filterState);
    },
    [filterState, filterString]
  );

  const applyFilter = (e) => {
    // alert("Apply clicked");
    // (appliedFilter);
    // (filterState);
    // (filterString);
    props.onClick(null);
    // setAppliedFilter(e.target);
    filterSubValue === "range"
      ? setFilterString(
        "&" + filterFinalType + filterSubValue + "=" + filterRangeFinalArray
      )
      : setFilterString(filterValueFinalString);

    // (filterSubValue==="range") ? setFilterString("&" + filterFinalType + filterSubValue + "=" + ["2022-05-01","2022-05-12"])
    // : setFilterString(filterValueFinalString);
  };

  const clearFilter = () => {
    setFilterString("");
    setFilterType("");
    setFilterFinalType("");
    setFilterSubValue("");
    setFilterValueFinalString("");
  };
  let curr = new Date();
  curr.setDate(curr.getDate());
  let getCurrentdate = curr.toISOString().substring(0, 10);
  return (
    <div className="filter-bg">
      <div
        className="filter-parent"
        style={{
          border: "1px solid #ddd",
          padding: 10,
          minHeight: 150,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        {/* { filterArray.map((item) => 
          <span style={{padding: 5, marginTop: 5, marginRight: 5, border:'1px solid #eee', borderRadius: 3, fontSize: 10, display:'inline'}}>{item.Status}</span>
        )} */}

        <div
          className="filter-child"
          style={{
            width: 400,
            padding: 10,
            display: "flex",
            columnGap: 30,
            justifyContent: "space-between",
          }}
        >
          <div className="filter-aside">
            <select
              onChange={handleChangeFilter}
              // onChange={x=>updateFilter(x.target.value, x.target.name, "option")}
              style={{ width: 180, height: 40, padding: 10 }}
              className="filter-select"
              name={filterType}
            >
              <option value="">Select</option>
              {filterList.map((filter) => (
                <option key={filter.id} value={filter.name}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-aside">
            {showSubMenu && (
              <>
                {/* if filter type is status or Rm name*/}
                {(filterType === "Status" ||
                  filterType === "RM Name" ||
                  filterType === "Country" ||
                  filterType === "Subscription Status" ||
                  filterType === "Conditions" ||
                  filterType === "Referrals Shared" ||
                  filterType === "Referral Bonus" ||
                  filterType === "Preferred Language") && (
                    <select
                      onChange={handleChangeSubFilter}
                      style={{ width: 180, height: 40, padding: 10 }}
                      className="filter-select"
                      name={filterValue}
                    >
                      <option value="">Select</option>
                      {filterList.map(
                        (filter) =>
                          filter.name === filterType &&
                          filter.options.map((option) => (
                            <option key={option.name} value={option.value}>
                              {option.name}
                            </option>
                          ))
                      )}
                    </select>
                  )}

                {/* if filter type is date*/}
                {(filterType === "Signup Date" ||
                  filterType === "Get Back Date" ||
                  filterType === "Renewal Date" ||
                  filterType === "Subscription Date" ||
                  filterType === "Date Time") && (
                    <>
                      <select
                        onChange={handleChangeSubFilter}
                        //onChange={handleRange}
                        style={{
                          width: 180,
                          height: 40,
                          padding: 10,
                          marginBottom: 5,
                        }}
                        className="filter-select"
                        name={filterValue}
                      >
                        <option value="">Select</option>
                        <option value="et">Equal to</option>
                        <option value="lte">Less than equal to</option>
                        <option value="gte">Greater than equal to</option>
                        <option value="range">Range</option>
                      </select>

                      {showSubChildMenu && (
                        <>
                          {/* if filter type is date*/}
                          {(filterSubValue === "et" ||
                            filterSubValue === "lte" ||
                            filterSubValue === "gte") && (
                              <>
                                <input
                                  type="date"
                                  onChange={handleChangeChildFilter}
                                  className="filter-date"
                                  name={filterValue}
                                  style={{ width: 175, height: 30 }}
                                  max={getCurrentdate}
                                />
                              </>
                            )}
                        </>
                      )}

                      {filterSubValue === "range" && (
                        <>
                          <label>From</label>
                          <input
                            type="date"
                            onChange={handleChangeChildRangeFilter}
                            className="filter-date"
                            name="from"
                            value={handleRangeData.from}
                            style={{ width: 175, height: 30, marginBottom: 5 }}
                            max={getCurrentdate}

                          />
                          <label>To</label>
                          <input
                            type="date"
                            onChange={handleChangeChildRangeFilter}
                            className="filter-date"
                            name="to"
                            value={handleRangeData.to}
                            style={{ width: 175, height: 30 }}
                            max={getCurrentdate}

                          />
                        </>
                      )}
                    </>
                  )}
                {(filterType === "ref_shared_value" ||
                  filterType === "ref_bonus_value") && (
                    <input
                      type="text"
                      onChange={handleChangeSubFilter}
                      className="filter-date"
                      name={filterValue}
                      style={{ width: 175, height: 30 }}
                    />
                  )}
              </>
            )}
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", columnGap: 20 }}
        >
          <Button variant="contained" onClick={applyFilter} color="primary">
            Apply
          </Button>
          <Button variant="contained" onClick={clearFilter} color="default">
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
}

const useFilter = (url) => {
  const [filterState, setFilterState] = React.useState([]);
  const [filterList, setFilterList] = React.useState([]);
  // (filterList);
  const [appliedFilter, setAppliedFilter] = React.useState([]);
  // (appliedFilter);
  const [filterString, setFilterString] = React.useState("");
  const [takenFilter, setTakenFilter] = React.useState();
  // (takenFilter);
  useEffect(() => {
    // setFilterString();
    // http.get(url+'-filter').then(res=>{
    //     setFilterState(generateEmptyFilterState(res.data));
    //     setFilterList(res.data);
    // })
    // setFilterState(generateEmptyFilterState(filterList));
  }, [filterList]);
  useEffect(
    (x) => {
      // (filterState);
    },
    [filterState, appliedFilter]
  );

  useEffect(
    (x) => {
      // (filterString);
    },
    [filterString]
  );

  const clearFilter = () => {
    // setAppliedFilter([]);
    // setFilterList([]);
    setFilterString([]);
  };

  const generateFilterList = (fl) => {
    setFilterList((x) => {
      //generate a random 10 alpha numeric string as id
      return fl.map((x) => ({
        ...x,
        id: Math.random().toString(36).substr(2, 10),
      }));
    });
  }; // check

  const passData = {
    clearFilter,
    setAppliedFilter,
    filterState,
    setFilterState,
    filterList,
    filterString,
    setFilterString,
  };

  //setFilterList, Filter, filterString,
  //forwardProps: {clearFilter, setAppliedFilter, filterState, setFilterState, filterList }

  const passFilters = generateFilterList; // syntax sugar
  // (Filter);
  // (Filter.finalFilterString);
  // (filterString);
  // (passFilters);
  // (passData);
  // return [Filter, filterString, passFilters, passData];
  // const filterString = "";
  return [Filter, filterString, passFilters, passData];
  // return [
  //     clearFilter,
  //     filterString, setAppliedFilter,
  //     filterState, setFilterState,
  //     filterList, generateFilterList
  //     Filter,
  //     getFilterParams,
  // ]
};

export default useFilter;

// export default Filter;
